module.exports = __webpack_public_path__ + "static/media/domcamera-removebg-preview.c9c10703.png";